export default __webpack_public_path__ + "static/media/pop.271f19cd.mp3";